import { createContext } from 'react';
export const MainContentContext = createContext(null);
